// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1902":"f800fcbe63bb9c3b","3066":"4498a5341442d1d5","3265":"729758c10e659399","6392":"1a63ee692cc6e897","7429":"b9bcddb0e1ec10e2","7654":"c27953a1da01f0b1"}[chunkId] + ".js";
};